module.exports = __webpack_public_path__ + "eefc2e2ecf6f98f55363fd9c3449896a.svg";